module.exports = __webpack_public_path__ + "media/static/icons/icon-river--red-f38bb6efe16c81d01265d1f9e3064e8a.svg";